import LayoutData from '../../F/Admin/LayoutData';

/**
 * 관리자 부팅관리
 */
export default {
    initialize: function () {
        // 회원 표기(`data-mb-pop`)는 사이드바 없는 팝업·bare 화면에도 서버가 그린다 — 사이드바 판정보다 먼저 건다
        $j.F.Admin.Member.Pop.autoBind();

        // 불러톡 패널 실측+리스너 — 토스트 위치 CSS변수(--adm-navh 등)도 여기서 재므로 팝업/bare 에서도 돈다
        $j.F.Admin.ChatPanel.init();

        if( !$('.main-sidebar').length ) return;

        $j.F.Admin.Menu.init();
        $j.F.Admin.Util.Talk_notice_check();
        $j.F.Admin.Notification.initAlimHandler();

        this.initMemberSearch();
        this.initHeader();
    },

    /** 헤더 — 채팅 아이콘 · 프로필 아바타 바꾸기 */
    initHeader: function () {
        $('#chatIcon').on('click', function (e) {
            e.preventDefault();
            $j.F.Admin.Util.chatList();
        });

        // 아바타 클릭 → 고르기 창(이모지 얼굴·색 + 사진 올리기).
        // 요소에 직접 건다 — 클릭이 문서까지 올라가면 프로필 드롭다운이 닫힌다
        $('.admin-avatar-edit').on('click', function (e) {
            e.stopPropagation();
            $j.F.Admin.ProfileAvatar.open(LayoutData.get('avatarNow', ''));
        });

        // 사진 올리기 결과 — 업로드 모듈이 이벤트로 돌려준다
        $j.Common.EventBus.on(G5['NS'], 'upload:image', function (e, payload) {
            if ($j.F.Upload.getContext() !== 'adminProfile') return;
            const file = Array.isArray(payload) ? payload[0] : payload;
            $.ajax({
                type: 'POST',
                url: '/adm/ajax/manager/profile-image',
                data: file,  // {id, path, host, type}
                success: function (r) {
                    if (r.result !== true) { alert(r.message || '프로필 이미지 변경에 실패했습니다.'); return; }
                    location.reload();
                },
                error: function () { alert('업로드 중 오류가 발생했습니다.'); }
            });
        });
    },

    /**
     * 관리자 헤더에서 기사검색 모달을 띄운다.
     * - window.openMemberSearch(): 헤더 버튼/코드에서 호출
     * - 헤더(.main-header) 더블클릭 또는 길게 누르기(롱클릭)로 오픈.
     *   헤더의 실제 컨트롤(메뉴·알림·유저메뉴·버튼·링크)은 제외해 원래 동작을 방해하지 않는다.
     */
    initMemberSearch: function () {
        window.openMemberSearch = function () {
            if (location.pathname.replace(/\/$/, '') === '/adm/members') return; // 기사관리 페이지엔 이미 검색이 있어 불필요
            if ($('#member-search-modal').is(':visible')) return; // 이미 열려있으면 무시
            $j.Ui.JBModal.target('member-search-modal', {
                target: '$j.F.Admin.Member.SearchModal',
                title:  '기사 검색',
                width:  '1200px',
            });
        };

        const $header = $('.main-header');
        if (!$header.length) return;

        // 헤더의 실제 컨트롤 위에서는 제스처 무시 (버튼/링크/드롭다운/입력)
        const onControl = (e) => $(e.target).closest('a, button, input, select, label, .dropdown-menu, .user-menu').length > 0;

        // 더블클릭
        $header.on('dblclick', function (e) {
            if (onControl(e)) return;
            window.openMemberSearch();
        });

        // 롱클릭 (600ms 이상 누르고 있기) — 마우스·터치 공용
        let pressTimer = null;
        const startPress = (e) => {
            if (e.type === 'mousedown' && e.which !== 1) return; // 좌클릭만
            if (onControl(e)) return;
            pressTimer = setTimeout(() => { pressTimer = null; window.openMemberSearch(); }, 600);
        };
        const cancelPress = () => { if (pressTimer) { clearTimeout(pressTimer); pressTimer = null; } };

        $header.on('mousedown touchstart', startPress);
        $header.on('mouseup mouseleave touchend touchcancel touchmove', cancelPress);
    }
};
